<template>
  <div class="panel panel-default form-horizontal">
    <div class="panel-heading">
      <h5>
        Basic Information

        <i class="fa fa-question-circle" v-tooltip.bottom="tooltip"></i>
      </h5>
    </div>

    <div class="panel-body">
      <text-form-group
          :value="subscription.purchase_order"
          name="purchase_order"
          label="Purchase Order (PO number)"
          help-text="The subscriber's purchase order (not required)."
          :error="getError('purchase_order')"
          @input="update('purchase_order', $event)"
      ></text-form-group>

      <select-form-group
          :value="subscription.portal_id"
          name="portal_id"
          label="Portal"
          help-text="The portal that the subscription belongs to."
          :error="getError('portal_id')"
          @input="update('portal_id', $event)"
          :options="portalOptions"
      ></select-form-group>

      <select-form-group
          :value="subscription.subscription_type_id"
          name="subscription_type_id"
          label="Subscription Type"
          help-text="Any subscription type to use for the subscription."
          :error="getError('subscription_type_id')"
          @input="update('subscription_type_id', $event)"
          :options="subscriptionTypeOptions"
          :nullable="true"
          placeholder="(none)"
      ></select-form-group>

      <select-with-button-form-group
          v-model="subscription.contact_person_id"
          name="contact_person_id"
          label="Contact Person"
          help-text="The contact person in the company."
          :error="getError('contact_person_id')"
          :options="personOptions"
          @click="$emit('open-person-modal')"
      ></select-with-button-form-group>

      <select-form-group
          v-model="subscription.opportunity_id"
          name="opportunity_id"
          label="Opportunity"
          help-text="The opportunity that is converted into this subscription."
          :error="getError('opportunity_id')"
          :options="opportunityOptions"
          :nullable="true"
      ></select-form-group>

      <select-form-group
          v-model="subscription.meeting_id"
          name="meeting_id"
          label="Meeting"
          help-text="The meeting that is converted into this subscription."
          :error="getError('meeting_id')"
          :options="meetingOptions"
          :nullable="true"
          :disabled="hasOpportunity"
      ></select-form-group>
    </div>
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SelectWithButtonFormGroup from '@/components/FormGroups/Horizontal/SelectWithButton'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {SelectFormGroup, SelectWithButtonFormGroup, TextFormGroup},

  props: ['subscription', 'portals', 'subscriptionTypes', 'opportunities', 'meetings', 'people', 'errors'],

  model: {
    prop: 'subscription'
  },

  computed: {
    hasOpportunity() {
      return this.subscription.opportunity_id !== null && this.subscription.opportunity_id !== ''
    },

    portalOptions() {
      return this.portals.data.map(portal => {
        return {
          value: portal.id,
          label: portal.attributes.name
        }
      })
    },

    subscriptionTypeOptions() {
      return this.subscriptionTypes.data
          .filter(subscriptionType => subscriptionType.attributes.portal_id === parseInt(this.subscription.portal_id))
          .map(subscriptionType => {
            return {
              value: subscriptionType.id,
              label: subscriptionType.attributes.name
            }
          })
    },

    personOptions() {
      return this.people.data
          .filter(person => person.is_active)
          .map(person => {
            return {
              value: person.id,
              label: person.name
            }
          })
    },

    opportunityOptions() {
      return this.opportunities.data.map(opportunity => {
        return {
          value: opportunity.id,
          label: opportunity.attributes.user_full_name + ' - ' + this.$options.filters.date(opportunity.attributes.conversion_expected_at) + ' - ' + this.$options.filters.price(opportunity.attributes.value)
        }
      })
    },

    meetingOptions() {
      return this.meetings.data.map(meeting => {
        return {
          value: meeting.id,
          label: (meeting.attributes.title || 'Untitled meeting') + ' (' + this.$options.filters.datetime(meeting.attributes.starts_at) + ')'
        }
      })
    },

    tooltip() {
      return {
        content: '<p>' +
            'Enter the portal that the subscription subscribes to, and select a subscription type.' +
            '</p>',
        classes: 'help'
      }
    }
  },

  methods: {
    update(key, value) {
      this.$emit('input', {...this.subscription, [key]: value})
    },

    getError(name) {
      return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
    }
  }
}
</script>
